import React from 'react';
import PropTypes from 'prop-types';
import NavigationDrawer from 'components/NavigationDrawer';
import logoSrc from 'images/shared/AT_Main_Logo.png';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import MobileHomeLink from 'components/NavigationDrawer/MobileHomeLink';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import RoadblockedAnchor from 'react_components/branch/roadblocked_anchor';
import * as styles from './styles.module.scss';
import CustomIntlProvider from 'components/CustomIntlProvider';

const { ALLTRAILS } = StringConstantsMixin.strings;

function Right({ context, controllerName, currentPage, locationSlug }) {
  if (currentPage !== PageStrings.EXPLORE_ALL_PAGE) {
    if (locationSlug) {
      return (
        <RoadblockedAnchor
          cssId="mobile-explore-link"
          currentUser={context.currentUser}
          event="trail_header_map"
          href={`/explore/${locationSlug}?mobileMap=true`}
          innerHTML="Map"
          mobileBrowser={context.mobileBrowser}
        />
      );
    }

    if (controllerName === 'home' && !context.proUser) {
      return (
        <div>
          <MobileHomeLink />
        </div>
      );
    }
  }

  return <div className={styles.mobileRightSpacer} />;
}

Right.propTypes = {
  context: PropTypes.object.isRequired,
  controllerName: PropTypes.string.isRequired,
  currentPage: PropTypes.string.isRequired,
  locationSlug: PropTypes.string.isRequired
};

function MobileHeader({ context, controllerName, currentPage, locationSlug }) {
  return (
    <CustomIntlProvider>
      <div className={styles.mobileHeader}>
        <NavigationDrawer {...context} />
        <div>
          <a
            href={checkLinkAndAppendLanguage('/?ref=header')}
            onClick={() => {
              _gaq.push(['_trackEvent', 'Header Top', 'AllTrails Logo']);
            }}
          >
            <img alt={ALLTRAILS} className={styles.img} src={logoSrc} />
          </a>
        </div>
        <Right context={context} controllerName={controllerName} currentPage={currentPage} locationSlug={locationSlug} />
      </div>
    </CustomIntlProvider>
  );
}

MobileHeader.defaultProps = {
  currentPage: null,
  locationSlug: null
};

MobileHeader.propTypes = {
  context: PropTypes.object.isRequired,
  controllerName: PropTypes.string.isRequired,
  currentPage: PropTypes.string, // not defined on gifting
  locationSlug: PropTypes.string // not defined on gifting
};

export default MobileHeader;
